<template>
  <div class="home-content">
    <div class="first-pard">
      <span></span>
      <span>Asset</span>
      <div>
        <select v-model="timeType" @change="timeChange(timeType)">
          <option value="1" selected>Today</option>
          <option value="2">Yesterday</option>
          <option value="3">Last Week</option>
          <option value="4">Last Month</option>
          <option value="5">Last 3 Months</option>
          <option value="6">All Records</option>
          <option value="7">Conditional Query</option>
        </select>
      </div>
    </div>
    <div class="second-pard">
      <ul>
        <li :class="recordtype == 1 ? 'on' : ''" @click="changeNav(1)">Recharges</li>
        <li :class="recordtype == 2 ? 'on' : ''" @click="changeNav(2)">Withdraws</li>
        <li :class="recordtype == 3 ? 'on' : ''" @click="changeNav(3)">Funds</li>
      </ul>
    </div>
    <div class="search-pard" v-show="timeType==7">
      <div class="screenContent">
        <ul>
          <li>
            <span class="textleft">Select classification</span>
            <span class="textRight" @click="showStatusSearch = true">{{status.value}}</span>
          </li>
          <van-picker class="van_picker" toolbar-position="top" v-show="showStatusSearch" :columns="recordtype==3?moneyTypeList:statusList" :default-index="0" show-toolbar title="Select classification" @cancel="onCancelStatus" @confirm="onConfirmStatus" confirm-button-text="OK" cancel-button-text="Cancel"/>
          <li @click="showST">
            <span class="textleft">Start date</span>
            <span class="textRight" id="startTime">Select start time</span>
          </li>
          <li @click="showET">
            <span class="textleft">End date</span>
            <span class="textRight" id="endTime">Select end time</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="third-pard">
      <div v-if="!nodata && recordtype == 1">
        <div class="list" v-for="(i, index) in list" v-bind:key="index">
          <ul>
            <li class="des">
              <div>Amount</div>
              <div>{{ i.recharge_money }}</div>
            </li>
            <li class="des">
              <div>Status</div>
              <div>
                <span v-if="i.status == 1" style="color:#1087e7;">Applied</span>
                <span v-if="i.status == 2" style="color:#628808;">Agreed</span>
                <span v-if="i.status == 3" style="color:#f6543e;">Rejected</span>
                <button class="syt" v-if="i.status == 1" @click="toShouyt(i)">Checkout</button>
              </div>
            </li>
            <li class="des">
              <div>Apply Time</div>
              <div>{{ util.formatTime(i.add_time) }}</div>
            </li>
          </ul>
          <div class="lookDetail" @click="lookDetail(i)">
            <img src="@/assets/images/base/icon_righ_g.png" />
          </div>
        </div>
      </div>
      <div v-if="!nodata && recordtype == 2">
        <div class="list" v-for="(i, index) in list" v-bind:key="index">
          <ul>
            <li class="des">
              <div>Amount</div>
              <div>{{ i.withdraw_money }}</div>
            </li>
            <li class="des">
              <div>Status</div>
              <div>
                <span v-if="i.status == 1" style="color:#1087e7;">Applied</span>
                <span v-if="i.status == 2" style="color:#628808;">Agreed</span>
                <span v-if="i.status == 3" style="color:#f6543e;">Rejected</span>
              </div>
            </li>
            <li class="des">
              <div>Apply Time</div>
              <div>{{ util.formatTime(i.add_time) }}</div>
            </li>
          </ul>
          <div class="lookDetail" @click="lookDetail(i)"><img src="@/assets/images/base/icon_righ_g.png" /></div>
        </div>
      </div>
      <div v-if="!nodata && recordtype == 3">
        <div class="list" v-for="(i, index) in list" v-bind:key="index">
          <ul>
            <li class="des">
              <div>Fund Amount</div>
              <div>
                <span v-if="i.money_type == 1" style="color:#628808;font-weight: bold;">-{{ i.money }}</span>
                <span v-if="i.money_type == 2" style="color:#f6543e;font-weight: bold;">+{{ i.money }}</span>
                <span v-if="i.money_type == 3" style="color:#628808;font-weight: bold;">-{{ i.money }}</span>
                <span v-if="i.money_type == 4" style="color:#f6543e;font-weight: bold;">+{{ i.money }}</span>
                <span v-if="i.money_type == 5" style="color:#f6543e;font-weight: bold;">+{{ i.money }}</span>
                <span v-if="i.money_type == 6" style="color:#f6543e;font-weight: bold;">+{{ i.money }}</span>
                <span v-if="i.money_type == 7" style="color:#f6543e;font-weight: bold;">+{{ i.money }}</span>
                <span v-if="i.money_type == 8" style="color:#628808;font-weight: bold;"> -{{ i.money }}</span>
              </div>
            </li>
            <li class="des">
              <div>Fund Type</div>
              <div>
                <span v-if="i.money_type == 1" style="color:#1087e7;">User Order</span>
                <span v-if="i.money_type == 2" style="color:rgb(29, 159, 0);">User Recharge</span>
                <span v-if="i.money_type == 3" style="color:rgb(236, 10, 236);">User Withdraw</span>
                <span v-if="i.money_type == 4" style="color:rgb(160, 124, 15);">User Cancel</span>
                <span v-if="i.money_type == 5" style="color:rgb(131, 24, 128);">System Cancel</span>
                <span v-if="i.money_type == 6" style="color:rgb(248, 15, 143);">Order Profit</span>
                <span v-if="i.money_type == 7" style="color:rgb(214, 96, 161);">System Recharge</span>
                <span v-if="i.money_type == 8" style="color:rgb(233, 13, 50);">System Deduction</span>
              </div>
            </li>
            <li class="des">
              <div>Fund Time</div>
              <div>{{ util.formatTime(i.add_time) }}</div>
            </li>
            <!-- <li class="des">
              <div>交易备注</div>
              <div>{{ i.remark }}</div>
            </li> -->
          </ul>
          <div class="lookDetail"></div>
        </div>
      </div>
      <div class="nodata" v-if="nodata"><img src="@/assets/images/icon/data_icon_219962.png" /><span>No data available</span></div>
      <div class="show-more" v-if="list.length >= 10" @click="showMore()">{{ hasMore ? "See more records, click here" : "No more data" }}</div>
    </div>

    <div class="detail-pard" v-if="isDetail">
      <div class="detail-head">
        <div @click="toList()"><img src="@/assets/images/base/icon_righ_g.png" /></div>
        <div v-if="recordtype == 1">Recharge Detail</div>
        <div v-if="recordtype == 2">Withdraw Detail</div>
        <div></div>
      </div>
      <div class="detail-content">
        <ul v-if="recordtype == 1">
          <li class="des">
            <div>Transaction No.</div>
            <div class="recharge-edit" v-if="one.status == 1">
              <input type="text" v-model="one.transaction_no" maxlength="20" />
            </div>
            <div v-else>{{ one.transaction_no }}
              <button v-if="!!one.transaction_no" v-clipboard:error="util.onError" v-clipboard:copy="one.transaction_no" v-clipboard:success="util.onCopy">Copy</button>
            </div>
          </li>
          <li class="des">
            <div>Amount</div>
            <div>{{ one.recharge_money }}</div>
          </li>
          <li class="des">
            <div>Status</div>
            <div>
              <span v-if="one.status == 1" style="color:#1087e7;">Applied</span>
              <span v-if="one.status == 2" style="color:#628808;">Agreed</span>
              <span v-if="one.status == 3" style="color:#f6543e;">Rejected</span>
            </div>
          </li>
          <li class="des">
            <div>Order No.</div>
            <div>{{ one.order_no }}
              <button v-clipboard:error="util.onError" v-clipboard:copy="one.order_no" v-clipboard:success="util.onCopy">Copy</button>
            </div>
          </li>
          <!-- <li class="des">
            <div>渠道名称</div>
            <div>{{ one.channel_name }}</div>
          </li> -->
          <li class="des">
            <div>Apply Time</div>
            <div>{{ util.formatTime(one.add_time) }}</div>
          </li>
          <li class="des">
            <div>Review Time</div>
            <div>{{ util.formatTime(one.confirm_time) }}</div>
          </li>
          <li class="des">
            <div>Approve Amt.</div>
            <div>{{ one.confirm_money == 0 ? '' : one.confirm_money }}</div>
          </li>
          <li class="des">
            <div>Comment</div>
            <div>{{ one.confirm_reason }}</div>
          </li>
          <li class="des">
            <div>Recharge Info.</div>
            <div class="recharge-edit" v-if="one.status == 1">
              <textarea v-model="one.payment_info" maxlength="200"></textarea>
            </div>
            <div v-else>
              {{ one.payment_info }}
            </div>
          </li>
          <div v-if="one.status == 1">
            <button class="btn-submit" v-show="!showloding" @click="submitbtn">Supply Recharge Info.</button>
            <button class="btn-submit" v-show="showloding">Supply Recharge Info.</button>
          </div>
        </ul>
        <ul v-if="recordtype == 2">
          <li class="des">
            <div>Amount</div>
            <div>{{ one.withdraw_money }}</div>
          </li>
          <li class="des">
            <div>Status</div>
            <div>
              <span v-if="one.status == 1" style="color:#1087e7;">Applied</span>
              <span v-if="one.status == 2" style="color:#628808;">Agreed</span>
              <span v-if="one.status == 3" style="color:#f6543e;">Rejected</span>
            </div>
          </li>
          <li class="des">
            <div>Type</div>
            <div>
              <span v-if="one.withdraw_type == 1">BTC</span>
              <span v-if="one.withdraw_type == 2">ETH</span>
              <span v-if="one.withdraw_type == 3">USDT</span>
              <span v-if="one.withdraw_type == 4">Bank Card</span>
            </div>
          </li>
          <li class="des">
            <div>Address</div>
            <div style="font-size: 0.3rem;">{{ one.withdraw_adds }}
              <button v-if="!!one.withdraw_adds" v-clipboard:error="util.onError" v-clipboard:copy="one.withdraw_adds" v-clipboard:success="util.onCopy">Copy</button>
            </div>
          </li>
          <li class="des">
            <div>Apply Time</div>
            <div>{{ util.formatTime(one.add_time) }}</div>
          </li>
          <li class="des">
            <div>Review Time</div>
            <div>{{ util.formatTime(one.confirm_time) }}</div>
          </li>
          <li class="des">
            <div>Approve Amt.</div>
            <div>{{ one.confirm_money == 0 ? '' : one.confirm_money }}</div>
          </li>
          <li class="des" v-if="one.status == 3"  @click="get_reason_value(true,one.confirm_reason)">
            <div>Failure Reason</div>
            <div class="ellipsis" style="color: #f6543e;">{{ one.confirm_reason }}</div>
          </li>
          <li class="des" v-else>
            <div>Comment</div>
            <div>{{ one.confirm_reason }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="app_shadow" v-if="show_reason">
      <div class="reason_box">
        <div class="reason_title">
          Failure Reason
          <div class="close_btn"  @click="get_reason_value(false, '')">
            <img src="@/assets/images/base/close.png" />
          </div>
        </div>
        <textarea disabled class="reason_value" v-html="reason_value"></textarea>
      </div>
    </div>
    <FootMenu />
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
/*global mui*/
import Vue from "vue";
import Rolldate from "rolldate";
import { Loading } from "vant";
import VueClipboard from "vue-clipboard2";
import { Calendar } from 'vant';
import { Cell } from 'vant';
import { Picker } from 'vant';
Vue.use(Loading);
Vue.use(VueClipboard);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(Picker);
import FootMenu from "@/coms/footmenu.vue";
export default {
  components: {
    FootMenu
  },
  data() {
    return {
      showloding: false,
      timeType: 1,
      addTime: this.util.todayTime(1),
      nodata: true,
      recordtype: 1,
      pageNo: 1,
      pageSize: 10,
      hasMore: true,
      list: [],
      isDetail: false,
      one: {},
      status:{index:0,value:'Whole'},
      statusList:['Whole','Applied','Agreed','Rejected'],
      moneyTypeList:['Whole','User Order','User Recharge','User Withdraw','User Cancel','System Cancel','Order Profit','System Recharge','System Deduction'],
      showStatusSearch:false,
      ST: 0,
      ET: 0,
      show_reason: false,
      reason_value: ''
    };
  },
  methods: {
    get_reason_value(type,data) {
      this.show_reason = type
      this.reason_value = data
    },
    showST() {
      let _this = this;
      let rd = new Rolldate({
        el: "#startTime",
        format: "YYYY/MM/DD",
        beginYear: 2000,
        endYear: 2100,
        minStep: 1,
        lang: { 
          cancel: 'Cancel', 
          title: "Select start time",
          confirm: "Confirm",
          year: "",
          month: "",
          day: ""
        },
        trigger: "tap",
        confirm: function(date) {
          date = date + " 00:00:00";
          _this.ST = (Date.parse(date) / 1000).toFixed(0);
          if (_this.ET > 0 && _this.ST > _this.ET) {
            mui.toast("Start time cannot be greater than end time");
          }else{
            _this.timeBetweenSearch();
          }
        }
      });
      rd.show();
    },
    showET() {
      let _this = this;
      let rd = new Rolldate({
        el: "#endTime",
        format: "YYYY/MM/DD",
        beginYear: 2000,
        endYear: 2100,
        minStep: 1,
        lang: { 
          cancel: 'Cancel', 
          title: "Select start time",
          confirm: "Confirm",
          year: "",
          month: "",
          day: ""
        },
        trigger: "tap",
        confirm: function(date) {
          date = date + " 23:59:59";
          _this.ET = (Date.parse(date) / 1000).toFixed(0);
          if (_this.ST > 0 && _this.ST > _this.ET) {
            mui.toast("Start time cannot be greater than end time");
          }else{
            _this.timeBetweenSearch();
          }
        }
      });
      rd.show();
    },
    onCancelStatus(){
      this.showStatusSearch = false;
    },
    toShouyt(i) {
      if (!i.payment_url) {
        mui.alert("Cashier does not exist");
      } else {
        window.location.href = i.payment_url;
      }
    },
    submitbtn() {
      if (!this.one.transaction_no) {
        mui.alert("Transaction No. Cannot be empty");
      } else if (!this.showloding) {
        let params = {
          rechargeId: this.one.id,
          transactionNo: this.one.transaction_no,
          paymentInfo: this.one.payment_info
        };
        this.util.setDnValueToken(params);
        this.axios.post(this.api.api_completeRechargeInfo, this.util.encodeSearchParams(params)).then(res => {
          this.showloding = false;
          this.isDetail = false;
          this.changeNav(1);
          if (res.data.code == 0) {
            mui.toast("Modification succeeded");
          } else {
            mui.toast(res.data.message);
          }
        }).catch(() => {
            this.showloding = false;
            mui.toast("Modification failed");
          });
      }
    },
    toList(){
      this.isDetail = false;
      this.changeNav(this.recordtype);
    },
    lookDetail(i) {
      this.isDetail = true;
      this.one = i;
      if (this.recordtype == 1) this.getOneRecharge();
      if (this.recordtype == 2) this.getOneWithdraw();
    },
    onConfirmStatus(value,index){
      this.status.index = index;
      this.status.value = value;
      this.showStatusSearch = false;
      this.hasMore = true;
      this.pageNo = 1;
      this.list = [];
      this.getList();
    },
    timeBetweenSearch() {
      this.addTime.startTime = this.ST;
      this.addTime.endTime =  this.ET;
      this.hasMore = true;
      this.pageNo = 1;
      this.list = [];
      this.getList();
    },
    changeNav(navIndex) {
      this.recordtype = navIndex;
      this.status.index=0;
      this.status.value='Whole';
      this.timeChange(this.timeType);
    },
    timeChange(type) {
      if(type==7){
        this.status.index=0;
        this.status.value='Whole';
        this.addTime.startTime = 0;
        this.addTime.endTime = 0;
        this.ST = 0;
        this.ET = 0;
        document.getElementById("startTime").innerHTML="";
        document.getElementById("endTime").innerHTML="";
      }else{
        this.addTime = this.util.todayTime(type);
      }
        this.hasMore = true;
        this.pageNo = 1;
        this.list = [];
        this.getList();
    },
    showMore() {
      if (this.hasMore) {
        this.pageNo += 1;
        this.getList();
      }
    },
    getOneRecharge() {
      let params = { rechargeId: this.one.id }
      this.util.setDnValueToken(params);
      this.axios.get(this.api.api_getOneRecharge, { params: params }).then(res => {
      this.showloding = false;
        if (res.data.code == 0) {
          this.one = res.data.data;
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    getOneWithdraw() {
      let params = { withdrawId: this.one.id }
      this.util.setDnValueToken(params);
      this.axios.get(this.api.api_getOneWithdraw, { params: params }).then(res => {
      this.showloding = false;
        if (res.data.code == 0) {
          this.one = res.data.data;
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    getList() {
      if (this.recordtype == 1) this.getRecharge(this.api.api_findRecharge);
      if (this.recordtype == 2) this.getRecharge(this.api.api_findWithdraw);
      if (this.recordtype == 3) this.getRecharge(this.api.api_findMoneyRecord);
    },
    getRecharge(api) {
      this.showloding = true;
      let params = {
        status: this.status.index,
        startTime: this.addTime.startTime,
        endTime: this.addTime.endTime,
      }
      this.util.setDnValueUser(params);
      params.pageNo = this.pageNo;
      params.pageSize = this.pageSize;
      this.axios.get(api, { params: params }).then(res => {
        if (this.pageNo == 1) this.nodata = true;
        this.showloding = false;
        if (res.data.code == 0) {
          let list = res.data.data;
          if (list.length > 0) {
            this.nodata = false;
            this.list = this.list.concat(list);
          } else {
            this.hasMore = false;
          }
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
  },
  activated() {
    if(this.util.isLogin()) {
      this.status.index=0;
      this.status.value='Whole';
      this.addTime = this.util.todayTime(1),
      this.changeNav(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.32rem;
  background: rgb(235, 235, 235);
  color: rgb(103, 103, 103);
  width: 100%;
  height: 100%;

  .app_shadow {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.3);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .reason_box {
      width: 90%;
      background: #fff;
      border-radius: 10px;
      .reason_title {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 0.32rem;
        color: #333;
        font-weight: bolder;
        position: relative;
      }
      .reason_value {
        width: 100%;
        height: 60vh;
        line-height: 20px;
        font-size: 0.3rem;
        color: #f6543e;
        padding: 5px 10px;
        border: none;
      }
      .close_btn {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%);
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .first-pard {
    height: 36px;
    display: grid;
    grid-template-columns: 30% 1fr 30%;
    align-items: center;
    font-size: 0.36rem;
    text-align: center;
    font-weight: bold;
    color: black;

    select {
      cursor: pointer;
      background: rgb(235, 235, 235);
      height: 36px;
      font-size: 0.32rem;
      font-weight: normal;
      text-align: right;
      width: 90px;

      option {
        font-size: 0.3rem;
        text-align: right;
      }
    }
  }

  .second-pard {
    background-color: white;

    ul {
      display: flex;
      justify-content: center;
      align-items: center;

      li {
        font-size: 0.32rem;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 33.3%;
        border-bottom: 1px solid rgb(212, 212, 212);
      }

      .on {
        font-weight: bold;
        border-bottom: 3px solid #628808;
      }
    }
  }

  .third-pard {
    height: 100%;
    padding-bottom: 282px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    .nodata {
      margin-top: 50px;
      height: 50px;
      display: grid;
      justify-content: center;
      font-size: 0.32rem;

      img {
        display: block;
        width: 35px;
        margin: auto;
      }
    }

    .show-more {
      height: 50px;
      display: flex;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }

    .list {
      width: 98%;
      display: grid;
      grid-template-columns: 1fr 2%;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin: 10px auto;
      border-radius: 10px/10px;
      background-color: white;
      padding: 10px 8px;

      .des {
        display: grid;
        grid-template-columns: 35% 65%;
        padding: 2px 0;
        font-size: 0.32rem;
        word-wrap: break-word;
        overflow-wrap: break-word;
        :nth-child(1) {
          font-weight: bold;
          font-size: 0.32rem;
        }

        .syt {
          background: #628808;
          color: white;
          float: right;
          margin-right: 35px;
          padding: 0 5px;
        }
      }
    }

    .lookDetail {
      img {
        display: block;
        margin: auto;
        width: 18px;
      }
    }
  }

  .search-pard{
    .van_picker{
      background-color: rgb(164, 194, 219);
      width:100%;
      border-radius: 10px/10px;
    }

    .screenContent {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      padding-top: 0.2rem;
      ul {
        width: 100%;
        height: auto;
        background: #ffffff;
        padding: 0 0.3rem;
        li {
          width: 100%;
          height: 1rem;
          border-bottom: 1px solid #e8e5e5;
          // background: url(images/goRight.png)
            // no-repeat center right;
          background-size: 0.5rem 0.5rem;
          font-size: 0.34rem;
          line-height: 1rem;
          color: #000000;
          padding-right: 0.7rem;
          position: relative;
          #trigger {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            z-index: 2;
          }
          .textleft {
            display: flex;
            justify-content: left;
            align-items: center;
          }
          .textRight {
            width: 100%;
            position: absolute;
            top: 50%;
            right: 0.7rem;
            transform: translateY(-50%);
            text-align: right;
            font-size: 0.34rem;
            padding: 0;
            color: #333333;
            line-height: 0.4rem;
          }
        }
        :last-child{
          border-bottom: 0;
        }
      }
    }
  }

  .detail-pard {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 50px;
    z-index: 1;
    background: rgb(235, 235, 235);

    .detail-head {
      height: 50px;
      display: grid;
      grid-template-columns: 30% 1fr 30%;
      align-items: center;
      text-align: center;
      font-size: 0.34rem;
      font-weight: bold;
      color: black;

      :nth-child(1) {
        cursor: pointer;

        img {
          display: block;
          margin-left: 5%;
          width: 18px;
          transform: rotate(180deg);
        }
      }
    }

    .detail-content {
      ul {
        width: 98%;
        margin: 0 auto;
        border-radius: 10px/10px;
        background-color: white;
        padding: 10px 5px;

        .des {
          display: grid;
          grid-template-columns: 35% 65%;
          padding: 2px 0;
          font-size: 0.32rem;
          word-wrap: break-word;
          overflow-wrap: break-word;
          :nth-child(1) {
            font-weight: bold;  
            font-size: 0.32rem;
          }

          button {
            float: right;
            padding-right: 0px;
            color: brown;
          }
        }

        .recharge-edit {
          input {
            width: 98%;
            height: 30px;
            padding: 0 5px;
            border-radius: 5px/5px;
            border: 1px solid rgb(188, 188, 226);
          }

          textarea {
            width: 98%;
            height: 70px;
            padding: 0 5px;
            border-radius: 5px/5px;
            border: 1px solid rgb(188, 188, 226);
          }
        }
      }
    }

    .btn-submit {
      margin: 5px auto;
      width: 100%;
      border-radius: 4px;
      font-size: 0.32rem;
      height: 40px;
      background: #628808;
      color: white;
    }

    .btn-submit:hover {
      background: #628808;
    }
  }
}</style>  